export const iconFontAwesomeMapsMagnifyingGlass = (
	<i className="fa-solid fa-magnifying-glass"></i>
);
